import { Routes, Route } from "react-router";
import { RequireAdmin } from "./lib/auth";
import { AdminLayout } from "./components/layout/AdminLayout";
import { AdminLogin } from "./routes/Login";
import { AdminOverview } from "./routes/Overview";
import { AdminUsers } from "./routes/Users";
import { AdminOrganizations } from "./routes/Organizations";
import { AdminPlanFeatures } from "./routes/PlanFeatures";
import { AdminUserDetail } from "./routes/UserDetail";
import { Placeholder } from "./routes/Placeholder";
import { AdminAuditoria } from "./routes/Auditoria";
import { AdminSolicitacoesLgpd } from "./routes/SolicitacoesLgpd";
import { AdminExclusoesAgendadas } from "./routes/ExclusoesAgendadas";
import { AdminBaseDeMercado } from "./routes/BaseDeMercado";
import { AdminBaseCandidatos } from "./routes/BaseCandidatos";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route
        element={
          <RequireAdmin>
            <AdminLayout />
          </RequireAdmin>
        }
      >
        <Route index element={<AdminOverview />} />
        <Route path="usuarios" element={<AdminUsers />} />
        <Route path="usuarios/:id" element={<AdminUserDetail />} />
        <Route path="organizacoes" element={<AdminOrganizations />} />
        <Route path="planos-e-features" element={<AdminPlanFeatures />} />
        <Route path="auditoria" element={<AdminAuditoria />} />
        <Route path="database" element={<Placeholder title="Banco de dados" description="Estatisticas de uso e consultas." />} />
        <Route path="lgpd" element={<AdminSolicitacoesLgpd />} />
        <Route path="exclusoes" element={<AdminExclusoesAgendadas />} />
        <Route path="base" element={<AdminBaseDeMercado />} />
        <Route path="base/candidatos" element={<AdminBaseCandidatos />} />
      </Route>
      <Route path="*" element={<Placeholder title="404" description="Pagina nao encontrada." />} />
    </Routes>
  );
}
